import React from "react";
import IconSvg, { IconSvgProps } from "~/guidelines/Icon/IconSvg";

const NoElevator = ({ color }: IconSvgProps) => {
  return (
    <IconSvg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      color={color}
    >
      <path
        d="M11 1C8.79086 1 7 2.79086 7 5H9C9 3.89543 9.89543 3 11 3H18C19.1046 3 20 3.89543 20 5V19C20 20.1046 19.1046 21 18 21H11C9.89543 21 9 20.1046 9 19H7C7 21.2091 8.79086 23 11 23H18C20.2091 23 22 21.2091 22 19V5C22 2.79086 20.2091 1 18 1H11Z"
        fill="currentColor"
      />
      <path
        d="M9.21 7.69999C8.93 7.41999 8.49 7.41999 8.21 7.69999L4.71 11.2L1.21 7.69999C0.93 7.41999 0.49 7.41999 0.21 7.69999C-0.07 7.97999 -0.07 8.41999 0.21 8.69999L3.71 12.2L0.21 15.7C-0.07 15.98 -0.07 16.42 0.21 16.7C0.49 16.98 0.93 16.98 1.21 16.7L4.71 13.2L8.21 16.7C8.49 16.98 8.93 16.98 9.21 16.7C9.49 16.42 9.49 15.98 9.21 15.7L5.71 12.2L9.21 8.69999C9.49 8.41999 9.49 7.97999 9.21 7.69999Z"
        fill="currentColor"
      />
      <path
        d="M14.097 6.21986L12.0912 9.1874C11.8596 9.52684 12.0962 10 12.4953 10H16.5068C16.906 10 17.1376 9.53198 16.9109 9.1874L14.9052 6.21986C14.708 5.92671 14.2941 5.92671 14.097 6.21986Z"
        fill="currentColor"
      />
      <path
        d="M14.097 17.7801L12.0912 14.8126C11.8596 14.4732 12.0962 14 12.4953 14H16.5068C16.906 14 17.1376 14.468 16.9109 14.8126L14.9052 17.7801C14.708 18.0733 14.2941 18.0733 14.097 17.7801Z"
        fill="currentColor"
      />
    </IconSvg>
  );
};

export default NoElevator;
